import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';

// Components
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import LoadingSpinner from './components/UI/LoadingSpinner';

// Pages
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';
import Parks from './pages/Parks/Parks';
import ParkDetail from './pages/Parks/ParkDetail';
import Gallery from './pages/Gallery/Gallery';
import SocialMedia from './pages/SocialMedia/SocialMedia';
import Contact from './pages/Contact/Contact';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Upload from './pages/Upload/Upload';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--neutral-gray-50);
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  padding-top: ${props => props.isMobile ? '70px' : '80px'};
`;

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    // Simulate app initialization
    const initializeApp = async () => {
      try {
        // Check for existing user session
        const savedUser = localStorage.getItem('rvbt_user');
        if (savedUser) {
          setUser(JSON.parse(savedUser));
        }
        
        // Simulate loading time
        await new Promise(resolve => setTimeout(resolve, 1500));
      } catch (error) {
        console.error('App initialization error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('rvbt_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('rvbt_user');
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <AppContainer>
      <Navigation user={user} onLogout={handleLogout} isMobile={isMobile} />
      
      <MainContent isMobile={isMobile}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/parks" element={<Parks />} />
          <Route path="/parks/:id" element={<ParkDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/social" element={<SocialMedia />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/register" element={<Register onLogin={handleLogin} />} />
          <Route path="/upload" element={<Upload user={user} />} />
          {user && (
            <>
              <Route path="/dashboard" element={<Dashboard user={user} />} />
            </>
          )}
        </Routes>
      </MainContent>
      
      <Footer />
    </AppContainer>
  );
};

export default App;
